import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Hls from "hls.js";
import { R2DOMAIN } from "../../config";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SaveTipsDialog({ open, onClose }) {
  const videoRefs = [useRef(null), useRef(null)];
  const [currentVideo, setCurrentVideo] = useState(0);

  const videoSources = [
    `${R2DOMAIN}/4aa0c33a5f84081a234f2e6a5484fdc2.m3u8`,
    `${R2DOMAIN}/4aa0c33a5f84081a234f2e6a5484fdc2.m3u8`,
  ];

  // 初始化 HLS 播放器
  useEffect(() => {
    videoRefs.forEach((ref, i) => {
      if (ref.current && Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoSources[i]);
        hls.attachMedia(ref.current);
        ref.current.hlsInstance = hls;
      } else if (ref.current?.canPlayType("application/vnd.apple.mpegurl")) {
        ref.current.src = videoSources[i];
      }
    });
    return () => {
      videoRefs.forEach((ref) => {
        if (ref.current?.hlsInstance) {
          ref.current.hlsInstance.destroy();
        }
      });
    };
  }, []);

  // 滚动检测当前视频索引
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const height = e.target.clientHeight;
    const index = Math.round(scrollTop / height);
    setCurrentVideo(index);
  };

  // 根据 currentVideo 自动播放/暂停
  useEffect(() => {
    videoRefs.forEach((ref, i) => {
      const video = ref.current;
      if (!video) return;
      if (i === currentVideo) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, [currentVideo]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: { backgroundColor: "black" },
      }}
    >
      {/* 顶部导航栏 */}
      <AppBar sx={{ position: "fixed", background: "rgba(0,0,0,0.7)" }}>
        <Toolbar>
          <Typography sx={{ flex: 1 }} variant="h6">
            保存提示
          </Typography>
          <IconButton edge="end" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* 内容区域 */}
      <Box
        sx={{
          height: "100vh",
          overflowY: "scroll",
          scrollSnapType: "y mandatory",
          mt: 8,
        }}
        onScroll={handleScroll}
      >
        {[0, 1].map((i) => (
          <Box
            key={i}
            sx={{
              height: "calc(100vh - 64px)",
              position: "relative",
              scrollSnapAlign: "start",
            }}
          >
            <video
              ref={videoRefs[i]}
              controls={false}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                backgroundColor: "black",
              }}
              muted
              playsInline
            />

            {/* 视频右下角提示文字 + 按钮 */}
            <Box
              sx={{
                position: "absolute",
                bottom: 20,
                right: 20,
                textAlign: "right",
                color: "white",
                background: "rgba(0,0,0,0.4)",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" sx={{ mb: 1 }}>
                如果将电报小程序的快捷方式保存到手机桌面。
              </Typography>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                翻译成中文
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </Dialog>
  );
}
